import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbGraytableApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbGraytable';
    }

    /**
     * 根据ErmodelId 查询数据
     * @param ermodelId 
     * @returns 
     */
    public async getDbTableListByErModelId(ermodelId: number) {
        return await this.send({ ermodelId }, 'getDbTableListByErModelId', Methods.GET);
    }

    /**
     * 根据开发 TableId 获取灰度TableId
     * @param devTableId 
     * @returns 
     */
    public async getDbGrayTableByDevTableId(devTableId: number) {
        return await this.send({ devTableId }, 'getDbGrayTableByDevTableId', Methods.GET);
    }
}